export default "https://statics.cloudfastin.top/static/v1.27.25.1/store/images/no-image.gif?4400d0a404977cfd58fd402408b3fa65";